import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import {
  handleChange,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import CommonButton from "../../../components/buttons/CommonButton";
import ClienteDadosCNPJ from "./NovoClienteModal/ClienteDadosCNPJ";
import ClienteDadosCPF from "./NovoClienteModal/ClienteDadosCPF";
import ClienteDadosEx from "./NovoClienteModal/ClienteDadosEx";
import ClienteEndereco from "./NovoClienteModal/ClienteEndereco";
import LocalidadeApiClient from "../../../api/localidade";
import useApi from "../../../hooks/useApi";
import ErrorSwal from "../../../components/Swal/errorSwal";
import Validation from "../../../helpers/Validation";
import ClienteApiClient from "../../../api/cliente";
import { AppContext } from "../../../contexts/AppContext";
import OptionsSwal from "../../../components/Swal/optionsSwal";
import { Cores } from "../../../constants/Cores";
import CommonSwal from "../../../components/Swal/commonSwal";
import ReceitaApiClient from "../../../api/receita";
import PropTypes from "prop-types";

function NovoClienteModal({
  modalHook,
  valuesHook,
  clienteTabHook,
  editar = false,
  buscaClientes,
  resetaClientes,
  sentHook,
}) {
  const { novoClienteModal, setNovoClienteModal } = modalHook;
  const { clienteValues, setClienteValues } = valuesHook;
  const { clienteTab, setClienteTab } = clienteTabHook;
  const { sent, setSent } = sentHook;
  const { session } = React.useContext(AppContext);

  const { request: getCep, data: cepResponse } = useApi(
    LocalidadeApiClient.buscaCep
  );
  const verificaClienteApi = useApi(ClienteApiClient.verificaCliente);
  const putClienteApi = useApi(ClienteApiClient.putCliente);
  const postClienteApi = useApi(ClienteApiClient.postCliente);
  const getCnpjApi = useApi(ReceitaApiClient.getCnpj);

  const verificaDocumento = async () => {
    if (clienteValues.tipoDocumento !== "3") {
      if (!clienteValues.cnpj)
        return ErrorSwal({
          text: "Favor preencher todos os dados obrigatórios.",
        });

      if (
        clienteValues.tipoDocumento === "2" &&
        Validation.validaCnpj(clienteValues.cnpj)
      )
        return ErrorSwal({
          text: "Favor inserir um CNPJ válido.",
        });

      if (
        clienteValues.tipoDocumento === "1" &&
        Validation.validaCpf(clienteValues.cnpj)
      )
        return ErrorSwal({
          text: "Favor inserir um CPF válido.",
        });
    }

    const response = await verificaClienteApi.request(
      session.empresa.replace(/E/gi, ""),
      {
        documento:
          clienteValues.tipoDocumento === "3"
            ? "99999999999"
            : clienteValues.cnpj,
        tipo: clienteValues.tipoDocumento,
      }
    );
    if (!response) return;
    if (response.exist === true) {
      return ErrorSwal({
        text: "Um cliente já foi cadastrado com este CPF/CNPJ.",
      });
    } else {
      const newValues = { ...clienteValues, uid: response.uid };
      if (clienteValues.tipoDocumento === "3") {
        newValues.cnpj = "99999999999";
      }
      setClienteTab(1);
      setClienteValues(newValues);
      if (clienteValues.tipoDocumento === "2") {
        getDadosCnpj(newValues);
      }
    }
  };

  const salvaCliente = async () => {
    OptionsSwal({
      title: "Deseja realmente salvar os dados do cliente?",
      icon: "warning",
      confirmButtonColor: Cores.buttons.azulConfirm,
      denyButtonColor: Cores.buttons.cinzaDeny,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSent(true);
        const { erros, formData } = validaCliente();

        if (erros)
          return ErrorSwal({
            text: erros,
          });

        var response;
        if (editar) {
          response = await putClienteApi.request(
            session.empresa.replace(/E/gi, ""),
            clienteValues.uid,
            formData
          );
        } else {
          response = await postClienteApi.request(
            session.empresa.replace(/E/gi, ""),
            formData
          );
        }
        if (!response) return;
        await buscaClientes(session.empresa.replace(/E/gi, ""));
        CommonSwal({
          icon: "success",
          title: "Dados do cliente salvos com sucesso!",
        });
        setNovoClienteModal(false);
        resetaClientes();
      }
    });
  };

  const validaCliente = () => {
    const formData = new FormData();
    var erros;

    if (clienteValues.cnpj === "99999999999") {
      formData.append("uid", clienteValues?.uid || "");
      formData.append("razao_social", clienteValues?.razao_social || "");
      formData.append("logradouro", clienteValues?.logradouro || "");
      formData.append("numero", String(clienteValues?.numero) || "");
      formData.append("cidade", clienteValues?.cidade || "");
      formData.append("uf", clienteValues?.uf || "");
      formData.append("cnpj", clienteValues?.cnpj || "");
      formData.append("optante_simples", 0);
      erros =
        Validation.verificarForm(formData) &&
        "Favor preencher todos os dados obrigatórios.";
      if (
        (clienteValues?.razao_social &&
          clienteValues?.razao_social.length > 75) ||
        (clienteValues?.logradouro && clienteValues?.logradouro.length > 40)
      )
        erros = "Verifique a quantidade permitida de caracteres.";
    } else {
      formData.append("uid", clienteValues?.uid || "");
      formData.append("razao_social", clienteValues?.razao_social || "");
      formData.append("cnpj", clienteValues?.cnpj || "");
      formData.append("email", clienteValues?.email || "");
      formData.append("cep", clienteValues?.cep || "");
      formData.append("logradouro", clienteValues?.logradouro || "");
      formData.append("numero", String(clienteValues?.numero) || "");
      formData.append("bairro", clienteValues?.bairro || "");
      formData.append("cidade", clienteValues?.cidade || "");
      formData.append("uf", clienteValues?.uf || "");
      formData.append("codigo_cidade", clienteValues?.codigo_cidade || "");
      erros =
        Validation.verificarForm(formData) &&
        "Favor preencher todos os dados obrigatórios.";
      formData.append("telefone", clienteValues?.telefone || "");
      formData.append("celular", clienteValues?.celular || "");
      formData.append("complemento", clienteValues?.complemento || "");
      formData.append(
        "optante_simples",
        clienteValues?.optante_simples ? 1 : 0
      );
      if (clienteValues.cnpj.length > 11) {
        formData.append("nome_fantasia", clienteValues?.nome_fantasia || "");
        formData.append(
          "inscr_municipal",
          clienteValues?.inscr_municipal || ""
        );
      }
      if (
        (clienteValues?.razao_social &&
          clienteValues?.razao_social.length > 75) ||
        (clienteValues?.nome_fantasia &&
          clienteValues?.nome_fantasia.length > 75) ||
        (clienteValues?.logradouro && clienteValues?.logradouro.length > 40) ||
        (clienteValues?.bairro && clienteValues?.bairro.length > 30) ||
        (clienteValues?.complemento && clienteValues?.complemento.length > 30)
      )
        erros = "Verifique a quantidade permitida de caracteres.";
    }

    return { formData, erros };
  };

  const getDadosCnpj = async (newValues = []) => {
    try {
      const response = await getCnpjApi.request(clienteValues?.cnpj);

      if (!response) return;

      const newPhone = response?.telefone.replace(/[^0-9]/g, "").slice(0, 10);

      setClienteValues({
        ...newValues,
        ...clienteValues,
        razao_social: response.nome,
        nome_fantasia: response.fantasia,
        email: response.email,
        telefone: newPhone.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1)$2-$3"),
        logradouro: response.logradouro,
        numero: response.numero,
        complemento: response.complemento,
        bairro: response.bairro,
        cidade: response.municipio,
        uf: response.uf,
        cep: response.cep.replace(/[^0-9]/g, ""),
      });
      getCep(response.cep.replace(/[^0-9]/g, ""));
    } catch (e) {
      CommonSwal({
        title: "Oops!",
        text: "Ocorreu algum erro inesperado, se o problema persistir entre em contato com o suporte Orangiuz",
        icon: "error",
      });
    }
  };

  return (
    <CommonModal
      title="Novo cliente"
      is_open_modal={novoClienteModal}
      set_is_open_modal={setNovoClienteModal}
      size={clienteTab === 0 ? "md" : "lg"}
      customDeny={
        clienteTab === 0 ? (
          <button
            type="button"
            onClick={() => {
              setNovoClienteModal(false);
            }}
            className="btn btn-danger"
          >
            Cancelar
          </button>
        ) : (
          <CommonButton
            onClick={() => {
              setClienteTab(0);
              setClienteValues({
                cnpj: clienteValues.cnpj,
                tipoDocumento: clienteValues.tipoDocumento,
              });
            }}
            color="danger"
          >
            Voltar
          </CommonButton>
        )
      }
      buttons={
        clienteTab === 0 ? (
          <CommonButton onClick={verificaDocumento} color="success">
            Próximo
          </CommonButton>
        ) : (
          <>
            {clienteValues?.cnpj && clienteValues?.cnpj.length === 14 ? (
              <>
                <CommonButton
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_CONSULTA_CNPJ_URL,
                      "_blank"
                    );
                  }}
                  color="primary"
                >
                  Verificar regime
                </CommonButton>
                <CommonButton
                  onClick={() => {
                    getDadosCnpj();
                  }}
                  color="primary"
                >
                  Buscar dados pelo CNPJ
                </CommonButton>
              </>
            ) : null}
            <CommonButton onClick={salvaCliente} color="success">
              Salvar
            </CommonButton>
          </>
        )
      }
    >
      {clienteTab === 0 ? (
        <>
          <div className="row mb-3">
            <div className="col-md-6">
              <CommonSelect
                label="Tipo de documento"
                id="tipoDocumento"
                value={clienteValues.tipoDocumento}
                onChange={(e) => {
                  handleChange(e, clienteValues, setClienteValues);
                }}
                data={[
                  { id: "1", text: "CPF" },
                  { id: "2", text: "CNPJ" },
                  { id: "3", text: "Estrangeiro" },
                ]}
              />
            </div>
          </div>
          {clienteValues &&
          ["1", "2"].includes(clienteValues?.tipoDocumento) ? (
            <div className="row">
              <div className="col-md-6">
                <CommonInputMask
                  id="cnpj"
                  value={clienteValues.cnpj}
                  onChange={(e) => {
                    handleChangeUnmask(e, clienteValues, setClienteValues);
                  }}
                  mask={
                    clienteValues.tipoDocumento === "2"
                      ? "99.999.999/9999-99"
                      : "999.999.999-99"
                  }
                />
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <>
          {clienteValues?.cnpj ? (
            clienteValues?.cnpj === "99999999999" ? (
              <ClienteDadosEx
                sent={sent}
                valuesHook={{ clienteValues, setClienteValues }}
              />
            ) : clienteValues?.cnpj.length === 11 ? (
              <ClienteDadosCPF
                sent={sent}
                valuesHook={{ clienteValues, setClienteValues }}
              />
            ) : (
              <ClienteDadosCNPJ
                sent={sent}
                valuesHook={{ clienteValues, setClienteValues }}
              />
            )
          ) : null}
          {clienteValues?.cnpj === "99999999999" ? null : (
            <ClienteEndereco
              sent={sent}
              valuesHook={{ clienteValues, setClienteValues }}
              cepApi={{ getCep, cepResponse }}
            />
          )}
        </>
      )}
    </CommonModal>
  );
}

NovoClienteModal.propTypes = {
  modalHook: PropTypes.shape({
    novoClienteModal: PropTypes.bool.isRequired,
    setNovoClienteModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    clienteValues: PropTypes.object.isRequired,
    setClienteValues: PropTypes.func.isRequired,
  }).isRequired,
  clienteTabHook: PropTypes.shape({
    clienteTab: PropTypes.number.isRequired,
    setClienteTab: PropTypes.func.isRequired,
  }).isRequired,
  editar: PropTypes.bool,
  buscaClientes: PropTypes.func.isRequired,
  resetaClientes: PropTypes.func.isRequired,
  sentHook: PropTypes.shape({
    sent: PropTypes.number.isRequired,
    setSent: PropTypes.func.isRequired,
  }).isRequired,
};

export default NovoClienteModal;
